import { GET_MOBILE_NUMBER } from "../components/action-types"


const getMobileNumAndValidateReducer = (state = [], action) => {
    switch (action.type) {
        case (GET_MOBILE_NUMBER):
            return state = action.payload
        default:
            return state
    }
}

export default getMobileNumAndValidateReducer;